/* eslint-disable no-prototype-builtins */

const keyMirror = obj => {
  const ret = {};
  let key;
  if (!(obj instanceof Object && !Array.isArray(obj))) {
    throw new Error('keyMirror(...): Argument must be an object.');
  }
  for (key in obj) {
    if (!obj.hasOwnProperty(key)) {
      continue;
    }
    ret[key] = key;
  }
  return ret;
};
export const LawfulBasis = keyMirror({
  LEGITIMATE_INTEREST_PQL: null,
  LEGITIMATE_INTEREST_CLIENT: null,
  LEGITIMATE_INTEREST_OTHER: null,
  PERFORMANCE_OF_CONTRACT: null,
  CONSENT_WITH_NOTICE: null,
  NON_GDPR: null
});
export const LegalBasis = keyMirror({
  LEGITIMATE_INTEREST_PQL: null,
  LEGITIMATE_INTEREST_CLIENT: null,
  LEGITIMATE_INTEREST_OTHER: null,
  PERFORMANCE_OF_CONTRACT: null,
  CONSENT_WITH_NOTICE: null,
  NON_GDPR: null
});
export const OptStatuses = keyMirror({
  OPT_IN: null,
  OPT_OUT: null,
  NOT_OPTED: null
});
export const HISTORY_COLUMNS = keyMirror({
  subscription: null,
  newStatus: null,
  email: null,
  legalBasis: null,
  explanation: null,
  requestedBy: null,
  source: null,
  created: null
});